<div
  class="card plant-section"
  [class.modal]="modal()"
  [class.fine]="fine() && !detail()"
  [class.critical]="!fine() && !detail()"
  [class.detail]="detail()"
  [class.mobile]="isMobile()"
  [class.disabled]="editObject() && editObject() !== plant()"
>
  <div class="disabled-blocker"></div>

  <nz-card
    [nzTitle]="
      plant() && !plant()?.filtered
        ? renameBtn()
          ? renameheader
          : plantheader
        : undefined
    "
  >
    @if (!fine() || detail()) {
      <ng-content></ng-content>
    }

    @if (!detail() && plant() && !plant()?.filtered) {
      <div class="notdetail-card-content-wrapper">
        <span class="body-bold black-coral-text">
          <i
            nz-icon
            [nzType]="'icons:installation_agent'"
            class="svg-icon fillblackcoral"
          ></i>
          {{ getSensorCount() }} {{ i18n.langString("sensors_in") }}
          {{ plant()?.objectName }}
        </span>
      </div>
    }

    <div class="card-bottom-button-whole-wrapper">
      @if (!detail() && plant() && !plant()?.filtered) {
        <app-nav-button
          [primary]="true"
          [asset]="plant()"
          svgIcon="icons:plant"
          (clickEvent)="onNav()"
        >
          {{ i18n.langString("see_whole_plant") }}
        </app-nav-button>
      }
    </div>
  </nz-card>

  <ng-template #plantheader>
    @if (plant() && !plant()?.filtered) {
      <div class="plant-header">
        @if (!detail()) {
          <nz-avatar
            [nzSrc]="plant()?.thumbnail ? plant()?.thumbnail : defaultImage()"
            [nzSize]="isMobile() ? 40 : 38"
            nzText="Plant"
          >
          </nz-avatar>
          <h1 class="plant-title">{{ plant()?.objectName }}</h1>
        }
        @if (detail()) {
          <h2 class="plant-title">
            {{ plant()?.objectName }} [{{ getSensorCount() }}]
          </h2>
        }
        @if (closeBtn()) {
          <button (click)="closed.emit()" id="closeBtn">
            <i nz-icon [nzType]="'icons:exit'" class="svg-icon"></i>
          </button>
        }
      </div>
    }
  </ng-template>

  <ng-template #renameheader>
    <app-rename-card-header
      class="card-rename-header"
      (editCompleted)="OnEditComplete()"
      [location]="plant()"
      [parentArray]="parentArray()"
      [isEditable]="isEditable()"
      [editObject]="editObject()"
      (delete)="onDelete($event)"
      (nameError)="onNameError($event)"
    >
    </app-rename-card-header>
  </ng-template>
</div>
